import React from "react";
import { unstable_HistoryRouter as Router } from "react-router-dom";
import { createBrowserHistory, BrowserHistory } from "history";
import { ApolloProvider } from "@apollo/client";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

import {
  ConfigContextData,
  ConfigProvider,
  useConfig,
} from "./components/proposals/contexts/configContext";
import { UserProvider } from "./components/proposals/contexts/userContext";
import { ScreenSizeProvider } from "./components/proposals/contexts/screenSizeContext";
import { useClient } from "./apollo";
import { BodyWrapper } from "./components/App/App.style";
import Routes from "./components/App/Routes";
import { ThomasEventsWrapper } from "./components/ThomasEvents/ThomasEventsWrapper";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();

declare global {
  interface Window {
    analytics: any;
    CustomerTopNav: any;
    // eslint-disable-next-line camelcase
    __marketplace_frontend_env__: {
      [key: string]: string;
    };
    XGLOBALS: {
      [key: string]: string;
    };
  }
}

type RootProps = {
  config: ConfigContextData;
  history?: BrowserHistory;
};

type ComponentProps = {
  history?: BrowserHistory;
};

export const Component: React.FC<ComponentProps> = props => {
  const { history: propsHistory } = props;
  const client = useClient();
  const history = propsHistory || createBrowserHistory({ window });
  const { publicUrl } = useConfig();

  return (
    <ApolloProvider client={client}>
      <Router history={history} basename={publicUrl}>
        <UserProvider>
          <ThomasEventsWrapper>
            <ScreenSizeProvider>
              <BodyWrapper>
                <Routes />
              </BodyWrapper>
            </ScreenSizeProvider>
          </ThomasEventsWrapper>
        </UserProvider>
      </Router>
    </ApolloProvider>
  );
};

Component.defaultProps = {
  history: undefined,
};

const Root: React.FC<RootProps> = ({ config, history }) => {
  return (
    <ConfigProvider input={config}>
      <Component history={history} />
    </ConfigProvider>
  );
};

Root.defaultProps = {
  history: undefined,
};

export default Root;
